import { coin_list } from "./CoinList";
import { coin_info } from "./CoinInfo";
import { coin_price } from "./CoinPrice";
import { cwallet_user } from "./CwalletUser";
import { coin_withdraw_fee_list } from "./CoinWithdrawFeeList";
import { fait_list } from "./FaitList";
import { swap_coin_list } from "./SwapCoinList";
import { swap_coin_price } from "./SwapCoinPrice";
import { swap_record } from "./SwapRecord";
import { swap_record_list } from "./SwapRecordList";
import { user_swap_coin_price } from "./UserSwapCoinPrice";
import { user_swap_record_list } from "./UserSwapRecordList";
import { swap_create } from "./SwapCreate";
import { user_swap_create } from "./UserSwapCreate";
import { chain_list } from "./ChainList";

export const codeMap: { [key: string]: any } = {
  coin_list,
  coin_info,
  coin_price,
  cwallet_user,
  coin_withdraw_fee_list,
  fait_list,
  swap_create,
  swap_coin_list,
  swap_coin_price,
  swap_record,
  swap_record_list,
  user_swap_coin_price,
  user_swap_record_list,
  user_swap_create,
  chain_list,
};
